const VIRIDIS_GRADIENT = 'linear-gradient(to top, rgb(68 1 84) 0%, rgb(68 2 85) 2%, rgb(69 8 91) 4%, rgb(70 15 98) 6%, rgb(71 22 105) 8%, rgb(71 29 111) 10%, rgb(72 35 116) 12%, rgb(71 42 122) 14%, rgb(70 48 126) 16%, rgb(69 55 129) 18%, rgb(67 61 132) 20%, rgb(64 67 135) 22%, rgb(61 74 137) 24%, rgb(58 80 138) 26%, rgb(55 87 140) 28%, rgb(52 94 141) 30%, rgb(49 100 141) 32%, rgb(46 107 142) 34%, rgb(44 113 142) 36%, rgb(42 120 142) 38%, rgb(41 120 142) 40%, rgb(39 126 142) 42%, rgb(37 132 141) 44%, rgb(35 138 141) 46%, rgb(33 143 140) 48%, rgb(32 144 140) 50%, rgb(31 150 139) 52%, rgb(31 156 137) 54%, rgb(32 161 135) 56%, rgb(33 166 133) 58%, rgb(34 167 132) 60%, rgb(38 172 129) 62%, rgb(44 177 126) 64%, rgb(51 182 121) 66%, rgb(60 187 116) 68%, rgb(68 190 112) 70%, rgb(79 195 105) 72%, rgb(91 200 98) 74%, rgb(104 204 91) 76%, rgb(116 208 84) 78%, rgb(121 209 81) 80%, rgb(135 213 72) 82%, rgb(149 216 64) 84%, rgb(164 219 54) 86%, rgb(178 221 44) 88%, rgb(189 223 38) 90%, rgb(203 225 33) 92%, rgb(217 226 30) 94%, rgb(230 228 30) 96%, rgb(240 229 34) 98%, rgb(253 231 37) 100%)';

const VIRIDIS_COLOR_STOPS = [
  [68, 1, 84],
  [68, 2, 85],
  [69, 8, 91],
  [70, 15, 98],
  [71, 22, 105],
  [71, 29, 111],
  [72, 35, 116],
  [71, 42, 122],
  [70, 48, 126],
  [69, 55, 129],
  [67, 61, 132],
  [64, 67, 135],
  [61, 74, 137],
  [58, 80, 138],
  [55, 87, 140],
  [52, 94, 141],
  [49, 100, 141],
  [46, 107, 142],
  [44, 113, 142],
  [42, 120, 142],
  [41, 120, 142],
  [39, 126, 142],
  [37, 132, 141],
  [35, 138, 141],
  [33, 143, 140],
  [32, 144, 140],
  [31, 150, 139],
  [31, 156, 137],
  [32, 161, 135],
  [33, 166, 133],
  [34, 167, 132],
  [38, 172, 129],
  [44, 177, 126],
  [51, 182, 121],
  [60, 187, 116],
  [68, 190, 112],
  [79, 195, 105],
  [91, 200, 98],
  [104, 204, 91],
  [116, 208, 84],
  [121, 209, 81],
  [135, 213, 72],
  [149, 216, 64],
  [164, 219, 54],
  [178, 221, 44],
  [189, 223, 38],
  [203, 225, 33],
  [217, 226, 30],
  [230, 228, 30],
  [240, 229, 34],
  [253, 231, 37],
];

function formatValue(value) {
  return new Intl.NumberFormat('en-US', {
    maximumFractionDigits: 2,
  }).format(value);
}

function getHoveredValue(color, min, max) {
  if (!color) {
    return null;
  }

  const [red, green, blue, alpha] = color;

  if (alpha === 0) {
    return null;
  }

  let nearestIndex = 0;
  let nearestDistance = Number.POSITIVE_INFINITY;

  VIRIDIS_COLOR_STOPS.forEach(([stopRed, stopGreen, stopBlue], index) => {
    const distance = ((red - stopRed) ** 2) + ((green - stopGreen) ** 2) + ((blue - stopBlue) ** 2);

    if (distance < nearestDistance) {
      nearestDistance = distance;
      nearestIndex = index;
    }
  });

  const ratio = nearestIndex / (VIRIDIS_COLOR_STOPS.length - 1);

  return min + ((max - min) * ratio);
}

function getMarkerOffset(hoveredValue, minValue, maxValue) {
  if (hoveredValue === null) {
    return null;
  }

  const ratio = (hoveredValue - minValue) / (maxValue - minValue);

  return Math.min(100, Math.max(0, ratio * 100));
}

export {
  formatValue,
  getHoveredValue,
  getMarkerOffset,
  VIRIDIS_GRADIENT,
};
